export default __webpack_public_path__ + "static/media/daniel-eliashevskyi-T3Neg57nlYs-unsplash-1.0601b153.jpg";